/**
 * @author: Wangwei
 * @description: 打卡营首页 Tabs切换
 */
import React, { useEffect, useState } from 'react';
import CampListCard from './campListCard';
import styles from './css/campIndexTabs.less';
import { Tabs } from 'antd';
import { useRequest } from 'umi';
import { getCampProductist } from '@/utils/requests/camp/requests_index';
import { ProductVO } from '@/types/camp/campIndex/indexTypes';
import { useModel } from '@@/plugin-model/useModel';

const CampIndexTabs = () => {
  const { initialState } = useModel('@@initialState');
  const [tabsItems, setTabsItems] = useState<[]>();
  const [productList, setProductList] = useState<ProductVO[]>();
  const getCampProductistRequest = useRequest(
    () => {
      return getCampProductist();
    },
    {
      manual: true,
      onSuccess: (res) => {
        // console.log('res', res);
        const newItem = res.map((it: any) => {
          return {
            label: it.name,
            key: it.id,
            children: <CampListCard id={it.id} />,
          };
        });
        newItem.unshift({
          label: '全部',
          key: 'all',
          children: <CampListCard key="productsAll" id={-1} />,
        });
        setTabsItems(newItem);
      },
      onError: (e) => {},
    },
  );
  useEffect(() => {
    getCampProductistRequest.run();
    // console.log('initialState', initialState);
  }, []);

  return (
    <>
      <div className="flex_3" style={{ margin: '10px 0' }}>
        <span className="f24 fw600 flex_2">全部打卡营</span>
        {initialState &&
          (initialState.permission?.superAdmin ||
          initialState.permission?.createCamp ||
          initialState.permission?.manageCamp ||
          initialState.permission?.manageSomeCamp ||
          initialState.permission.manageQuestionBank ? (
            <a
              href="/v2/console/campsetings"
              className="flex_1 f14 col5a5 hover008"
              target="_blank"
            >
              <span style={{ marginRight: 12 }}>学习管理后台</span>
            </a>
          ) : (
            ''
          ))}
      </div>

      <div className={styles.camp_index_tabs}>
        <Tabs
          defaultActiveKey="1"
          destroyInactiveTabPane
          indicator={{ size: (origin) => origin + 26 }}
          items={tabsItems}
        />
      </div>
    </>
  );
};
export default CampIndexTabs;
